

const showAlert = (message) => {
    alert(message);
};

const getBaseUrl = () => {
    return window.env.baseUrl || ''; // Access the environment value
};

const goToUrl = (url) => {

    let http = "https://"; 
    if(getBaseUrl() == "localhost") 
        http ="http://";    
    
    return http+url;
};

export { 
    showAlert,
    goToUrl
}